import { render } from "./Signatures.vue?vue&type=template&id=4768720d&scoped=true"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"

import "./Signatures.vue?vue&type=style&index=0&id=4768720d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768720d"]])

export default __exports__